import { render, staticRenderFns } from "./LoadingTableView.vue?vue&type=template&id=9f88761c&"
import script from "./LoadingTableView.vue?vue&type=script&lang=ts&"
export * from "./LoadingTableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports